<template>
    <div class="recruiter_index_candidates">

        <div id="context_bar">
            <TopbarSearchRef />
            <!-- <TopbarAddRef/> -->
        </div>

        <titlePage>
            <template slot="titleBody">
                <h1 class="page-title title is-size-1">{{ $t('modules.refs.index.title') }}</h1>
                <h4 class="is-size-6 has-text-centered">{{ $t('modules.refs.index.subtitle') }}</h4>
            </template>
        </titlePage>

        <RefsList />

    </div>

</template>

<script>
import TitlePage from "@/components/layouts/titlePage"
// import TopbarAddRef from "../components/topbar/topbarAddRef"
import TopbarSearchRef from "../components/topbar/topbarSearchRef"
import RefsList from "../components/index/refsList"

import posed from 'vue-pose';


export default {
    name: 'RefsIndex',
    components: {
        // TopbarAddRef,
        TopbarSearchRef,
        TitlePage,
        RefsList
    },
    beforeCreate() {
        this.$store.dispatch('RefStore/CustomRefsList', {cat_id: -1})
        this.$store.dispatch('RefStore/indexCats', "custom")
    },
    data(){
        return {}
    },
    computed: {},
    methods: {}
}
</script>

<style lang="scss">
</style>

